import React from "react";
import { useAuth } from "../../context/AuthContext";
import OrderManager from "../../components/orders/OrderManager";
import VendedorDashboardPage from "./VendedorDashboardPage";

function PedidosPage() {
  const { user } = useAuth();
  
  // Si es vendedor (role_id: 2), mostrar su dashboard primero
  const isVendedor = user?.role_id === 2;

  return (
    <div className="pedidos-page">
      {isVendedor && (
        <div className="mb-4">
          <VendedorDashboardPage />
        </div>
      )}
      <OrderManager />
    </div>
  );
}

export default PedidosPage;
